export default __webpack_public_path__ + "static/7-f94af0c94a396a716490f1ca7f87e433.png";